// extracted by mini-css-extract-plugin
export default {"container":"PaymentShowCase_container__gJ027","yourBid":"PaymentShowCase_yourBid__xWYsL","balance":"PaymentShowCase_balance__f0LZo"};